import { AppSettings, PersistedDocument } from './types';

export const CURRENT_SCHEMA_VERSION = 1;

export const DEFAULT_SCRIPT =
`أهلاً بكم مشاهدينا الكرام في هذه النشرة الإخبارية المباشرة من استوديوهاتنا.
نبدأ جولتنا بأبرز العناوين والتطورات المتسارعة على الساحتين الإقليمية والدولية.
أكدت مصادر رسمية اليوم استمرار المباحثات الدبلوماسية الرامية لتعزيز الاستقرار الاقتصادي وتطوير البنية التحتية في المنطقة.
وفي سياق متصل، أعلنت اللجنة المنظمة للمؤتمر الدولي للطاقة المتجددة اختتام أعمالها بتبني حزمة مبادرات نوعية وشراكات استراتيجية واسعة النطاق.
تابعونا لمزيد من التفاصيل والتحليلات المباشرة مع مراسلينا في الميدان.`;

export const DEFAULT_SETTINGS: AppSettings = {
  fontSize: 64,
  fontFamily: 'sans',
  lineHeight: 1.7,
  textAlign: 'start',
  textColumnWidth: 'normal',
  textColorPreset: 'white',
  directionMode: 'auto',

  speed: 80,
  keepPaceOnFontChange: true,
  countdownSeconds: 3,
  modePreference: 'manual',

  mirrorMode: 'off',
  markerEnabled: true,
  markerColor: '#ff0000',
  markerWidth: 4,
  markerOffset: 24,
  markerOpacity: 1.0,
  markerSide: 'auto',

  focusAreaEnabled: false,
  focusAreaPosition: 40,
  focusAreaHeight: 22,
  focusAreaIntensity: 0.15,

  focusLinesEnabled: true,
  focusLinesThickness: 1,
  focusLinesOpacity: 0.6,

  focusMaskEnabled: true,
  focusMaskOpacity: 0.55,

  micDeviceId: '',
  voiceSensitivity: 1.0,
  voiceProvisionalEnabled: true,

  diagnosticsEnabled: false,
};

export const DEFAULT_DOCUMENT: PersistedDocument = {
  script: DEFAULT_SCRIPT,
  lastClearedScript: '',
  updatedAt: Date.now(),
};
